// extracted by mini-css-extract-plugin
module.exports = {"balloon":"_02712f2b3b--balloon--zcuMS","icon":"_02712f2b3b--icon--OMveG","blue":"_02712f2b3b--blue--YZWM4","green":"_02712f2b3b--green--q4ij2"};